import { translation } from '../core';
import type { fr } from './fr';

export const en = translation<typeof fr>()({
  days: { one: '{count} day', other: '{count} days' },
  dayAtTime: '{day} at {time}',
});
